module.exports = __webpack_public_path__ + "img/stepcounter-truck.fe8cd0f9.svg";